export default __webpack_public_path__ + "static/media/tabletscreen.fa9f4ba9.png";